
































































































































import Vue from 'vue';
import { Getter } from 'vuex-class';
import Component, { mixins } from 'vue-class-component';
import { mdiChevronRight } from '@mdi/js';
import _, { isEmpty } from 'lodash';

import DisplayPatient from '@/mixins/DisplayPatient';

import { VaccinationFolder } from '@/store/folder/types';

import PopinUpdateCheckbox from './PopinUpdateCheckbox.vue';
import PopinUpdateImpossible from './PopinUpdateImpossible.vue';
import PopinUpdateWarning from './PopinUpdateWarning.vue';
import PopinUpdateAuto from './PopinUpdateAuto.vue';

import { updateFolderAuto } from '@/services/api/save/api';
import { ParametresUtilisateur } from '@/store/parametresUtilisateur/types';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { adapteFormVaccinateurPs } from '@/components/Vaccination/InformationsVaccin/adapter';
import { mapActions } from 'vuex';

const Props = Vue.extend({
	props: {
		sticky: {
			type: Boolean,
			default: false
		},
		folder: {
			type: Object as () => VaccinationFolder,
			required: true
		}
	}
});

@Component({
	components: {
		PopinUpdateCheckbox,
		PopinUpdateImpossible,
		PopinUpdateWarning,
		PopinUpdateAuto
	},
	methods: {
		...mapActions('globalState', ['addLoading', 'removeLoading'])
	}
})
export default class SubHeader extends mixins(Props, DisplayPatient) {

	@Getter('infosVaccinationFolder/getFolderUpdateDisplay') folderUpdateDisplay!: boolean;
	@Getter('infosVaccinationFolder/getFolderUpdateAvailable') folderUpdateAvailable!: boolean;
	@Getter('infosVaccinationFolder/isRecapitulatif') isRecapitulatif!: boolean;
	@Getter('parametresUtilisateur/getParametresUtilisateur') parametresUtilisateur!: Map<string, ParametresUtilisateur>;
	@Getter('infosPSBEN/getInfosPSBEN') infosPsben!: InfosPSBEN;

	popinUpdateCheckbox = false;
	popinUpdateImpossible = false;
	popinUpdateWarning = false;
	popinUpdateAuto = false;
	folderUpdateAutoDisplay = false;
	responseUpdateAuto = {};

	updateAutoCodeErreur = '';
	updateAutoIsError = false;
	updateAutoOk = false;
	updateAutoFieldUpdates = [];

	chevronRight = mdiChevronRight;

	get hasLibelleRegime(): boolean {
		return !_.isEmpty(_.get(this.folder, 'libelleRegime'));
	}

	get affichageRegime() {
		return this.hasLibelleRegime ?
			this.folder.libelleRegime :
			'Régime ' + _.get(this.folder, 'codeGrandRegime');
	}

	goToIdentification(): void {
		this.$store.dispatch('infosVaccinationFolder/cleanVaccinationFolder');
		this.$router.push({
			name: 'accueil',
			query: Object.assign({}, this.$router.currentRoute.query)
		});
	}

	popInChoice() {
		if (!this.folderUpdateAvailable) {
			this.popinUpdateImpossible = true;
		}	else if (this.isRecapitulatif) {
			this.popinUpdateCheckbox = true;
		} else {
			this.popinUpdateWarning = true;
		}
	}

	popInChoiceUpdateAuto() {
		this.addLoading();
		const psDelegation = _.get(this.parametresUtilisateur, 'delegation');
		const ps = this.parametresUtilisateur.get(_.get(this.infosPsben, 'ps.numRPPS'));
		this.resetUpdateAuto();
		updateFolderAuto(this.folder.nirAssure,
			this.folder.dateNaissanceBeneficiaire,
			this.folder.rangBeneficiaire,
			this.folder.prescription?.prescriptionId,
			psDelegation,
			adapteFormVaccinateurPs(this.infosPsben, ps),
			true
		).then((responseApi) => {
			const errorCode = _.get(responseApi, 'data.value.errorCode');
			if (_.isEmpty(errorCode)) {
				this.$store.dispatch('infosVaccinationFolder/updateFolderAndFlags', responseApi);
				this.updateAutoFieldUpdates = _.get(responseApi, 'data.value.fieldUpdates');
				this.updateAutoOk = true;
			} else {
				this.updateAutoIsError = true;
				this.updateAutoCodeErreur = errorCode;
			}
			this.popinUpdateAuto = true;
			this.removeLoading();
		});
	}

	resetUpdateAuto() {
		this.updateAutoCodeErreur = '';
		this.updateAutoIsError = false;
		this.updateAutoOk = false;
		this.updateAutoFieldUpdates = [];
	}

	get patientStatus() {
		if (_.isEmpty(this.nir(this.folder))) {
			return 'Non affilié au régime d\'assurance maladie français';
		} else {
			if (_.isEqual(this.folder.nirAssure, this.folder.nirBeneficiaire) ||
				!this.hasNirBeneficiaire(this.folder)) {
				return this.isFeminin(this.folder) ? 'Assurée' : 'Assuré';
			} else {
				return 'Ayant Droit';
			}
		}
	}

	beforeUpdate() {
		this.folderUpdateAutoDisplay = (this.folder && !isEmpty(this.folder.numeroBon)
			&& this.folder.degrade === false);
	}

	created() {
		this.folderUpdateAutoDisplay = (this.folder && !isEmpty(this.folder.numeroBon)
			&& this.folder.degrade === false);
	}
}
